module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/chair-1-fee49b74df04c7cb10a854c261bea0a2.svg";